<template>
  <div>
    <div class="section-apply-professionals">
      <div class="row">
        <div class="col-md-10 offset-md-1">
          <h2 class="text-center">{{ $t('message.apply.what_is_beneat_title') }}</h2>
          <p class="text-left">{{ $t('message.apply.what_is_beneat_detail') }}</p>
          <p class="text-left">
            เราเป็นบริษัท Startup ที่ได้รับการสนับสนุน จากกระทรวงวิทยศาสตร์และเทคโนโลยี เพื่อการพัฒนาระบบการรับงานทำความสะอาดแบบพาร์ทไทม์ ผ่านเทคโนโลยี Application เพื่อให้คุณแม่บ้าน สามารถทำงานพาร์ทไทม์ได้ อย่างสะดวก รวดเร็ว และ ปลอดภัย ในยุคไทยแลนด์ 4.0
          </p>
          <div class="row">
            <div class="col-md-6 pl-0">
              <img src="/static/img/apply-news01.jpg" alt="BeNeat เป็นบริษัท Startup ที่ได้รับการสนับสนุน จากกระทรวงวิทยศาสตร์และเทคโนโลยี" class="img-fluid">
            </div>
            <div class="col-md-6 pr-0">
              <img src="/static/img/apply-news02.jpg" alt="ท่านรัฐมนตรีว่าการกระทรวงวิทยาศาตร์และเทคโนโลยี (ดร.สุวิทย์ เมษินทรีย์) เข้าเยี่ยมเยือนบริษัท" class="img-fluid">
            </div>
          </div>

          <p class="mt-3 text-left">
            ท่านรัฐมนตรีว่าการกระทรวงวิทยาศาตร์และเทคโนโลยี (ดร.สุวิทย์ เมษินทรีย์) เข้าเยี่ยมเยือนบริษัท และ ให้กำลังใจคุณแม่บ้าน
          </p>
          <p class="mt-3 text-left" v-html="$t('message.apply.sub_title')"></p>

          <h3 class="text-center">{{ $t('message.apply.introduce_video') }}</h3>
          <div class="embed-responsive embed-responsive-16by9">
            <iframe width="560"
                    height="315"
                    src="https://www.youtube.com/embed/XgnuTLmSHcA"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>

    <section class="content-padding">
      <div class="row">
        <div class="col-12">
          <h2 class="text-center">{{ $t('message.apply.why_work_with_beneat') }}</h2>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-sm-3 col-md-3 text-center">
          <img src="/static/img/wallet.svg" width="60">
          <h3 class="mt-3">รายได้ดี</h3>
          <p>ผู้ให้บริการในระบบส่วนใหญ๋ได้รับรายได้เฉลี่ยเดือนละ 20,000-40,000 บาท (ขึ้นอยู่กับความขยันและความตั้งใจทำงาน)</p>
        </div>
        <div class="col-sm-3 col-md-3 text-center">
          <i class="fal fa-clock" style="font-size: 60px; color: #1FBCD2;"></i>
          <h3 class="mt-3">{{ $t('message.apply.why_benefit_title01') }}</h3>
          <p>{{ $t('message.apply.why_benefit_detail01') }}</p>
        </div>
        <div class="col-sm-3 col-md-3 text-center">
          <img src="/static/img/protect.svg" width="60">
          <h3 class="mt-3">{{ $t('message.apply.why_benefit_title02') }}</h3>
          <p>{{ $t('message.apply.why_benefit_detail02') }}</p>
        </div>
        <div class="col-sm-3 col-md-3 text-center">
          <img src="/static/img/community.svg" width="60">
          <h3 class="mt-3">{{ $t('message.apply.why_benefit_title03') }}</h3>
          <p>{{ $t('message.apply.why_benefit_detail03') }}</p>
        </div>
      </div>
    </section>

    <section class="content-padding-gray">
      <h2 class="text-center">{{ $t('message.apply.how_it_works') }}</h2>
      <div class="row" v-if="!$mq.phone">
        <div class="col-md-6 col-sm-6 text-right">
          <img :src="appPictures[num]" class="professional-app">
        </div>
        <div class="col-md-6 col-sm-6">
          <div class="professional-app-step"
               :class="{'active': num === 0}"
               @click="num = 0">
            <div class="step-num">1
            </div>
            <h4>{{ $t(stepTitles[0]) }}</h4>
            <p>{{ $t(stepDetails[0]) }}</p>
          </div>
          <div class="clearfix"></div>
          <div class="professional-app-step"
               :class="{'active': num === 1}"
               @click="num = 1">
            <div class="step-num">2</div>
            <h4>{{ $t(stepTitles[1]) }}</h4>
            <p>{{ $t(stepDetails[1]) }}</p>
          </div>
          <div class="clearfix"></div>
          <div class="professional-app-step"
               :class="{'active': num === 2}"
               @click="num = 2">
            <div class="step-num">3
            </div>
            <h4>{{ $t(stepTitles[2]) }}</h4>
            <p>{{ $t(stepDetails[2]) }}</p>
          </div>
          <div class="clearfix"></div>
          <div class="professional-app-step"
               :class="{'active': num === 3}"
               @click="num = 3">
            <div class="step-num">4
            </div>
            <h4>{{ $t(stepTitles[3]) }}</h4>
            <p>{{ $t(stepDetails[3]) }}</p>
          </div>
          <div class="clearfix"></div>
          <div class="mt-3">
            <a href="https://itunes.apple.com/th/app/beneat-cleaner/id1323965255?mt=8" target="_blank">
              <img src="/static/img/btn-app-store.svg" class="img-app-download">
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a href="https://play.google.com/store/apps/details?id=com.beneat.android" target="_blank">
              <img src="/static/img/btn-play-store.svg" class="img-app-download">
            </a>
          </div>
        </div>
      </div>
      <template v-else>
        <div class="row">
          <div class="col-3 text-center">
            <div class="step-num-mobile"
                 :class="{'active': num === 0}"
                 @click="num = 0">1
            </div>
          </div>
          <div class="col-3 text-center">
            <div class="step-num-mobile"
                 :class="{'active': num === 1}"
                 @click="num = 1">2
            </div>
          </div>
          <div class="col-3 text-center">
            <div class="step-num-mobile"
                 :class="{'active': num === 2}"
                 @click="num = 2">3
            </div>
          </div>
          <div class="col-3 text-center">
            <div class="step-num-mobile"
                 :class="{'active': num === 3}"
                 @click="num = 3">4
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-4 text-center active">
            <h4>{{ $t(stepTitles[num]) }}</h4>
            <p>{{ $t(stepDetails[num]) }}</p>
          </div>
          <div class="col-12 mt-3 text-center">
            <img :src="appPictures[num]" class="professional-app">
          </div>
          <div class="col-12 mt-4 text-center">
            <a href="https://itunes.apple.com/th/app/beneat-cleaner/id1323965255?mt=8" target="_blank">
              <img src="/static/img/btn-app-store.svg" class="img-app-download">
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a href="https://play.google.com/store/apps/details?id=com.beneat.android" target="_blank">
              <img src="/static/img/btn-play-store.svg" class="img-app-download">
            </a>
          </div>
        </div>
      </template>
    </section>

    <section class="content-padding">
      <div class="row">
        <div class="col-md-8 offset-sm-2">
          <h2>{{ $t('message.apply.requirements') }}</h2>
          <ul class="maininfo-list">
            <li>{{ $t('message.apply.requirements01') }}</li>
            <li>{{ $t('message.apply.requirements02') }}</li>
            <li>{{ $t('message.apply.requirements03') }}</li>
            <li>{{ $t('message.apply.requirements04') }}</li>
            <li>{{ $t('message.apply.requirements05') }}</li>
          </ul>
          <br>
          <p>{{ $t('message.apply.registration_form_link') }}</p>
          <div class="embed-responsive embed-responsive-16by9 mt-3">
            <iframe width="560"
                    height="315"
                    src="https://www.youtube.com/embed/XgnuTLmSHcA"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    allowfullscreen></iframe>
          </div>
          <div class="embed-responsive embed-responsive-16by9 mt-4">
            <iframe width="560"
                    height="315"
                    src="https://www.youtube.com/embed/YaHw1mGL_kk"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    allowfullscreen></iframe>
          </div>
          <div class="embed-responsive embed-responsive-16by9 mt-4">
            <iframe width="560"
                    height="315"
                    src="https://www.youtube.com/embed/RqVnTkEySD4"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    allowfullscreen></iframe>
          </div>
          <div class="embed-responsive embed-responsive-16by9 mt-4">
            <iframe width="560"
                    height="315"
                    src="https://www.youtube.com/embed/PRUsSZZz4xU"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    allowfullscreen></iframe>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="mt-4">
                BeNeat Academy คือ ศูนย์ฝึกอบรมคุณแม่บ้านที่มีมาตรฐาน โดย คุณแม่บ้านทุกท่านในระบบ จะได้รับการฝึกสอนทั้งทาง ทฤษฎี และ ปฎิบัติโดยผู้เชี่ยวชาญของบีนีท ซึ่งเป็นหลักสูตรที่บีนีทมีการออกแบบมาอย่างดี และ เป็นลิขสิทธิ์เฉพาะ ของบีนีท
              </div>
              <div class="mt-4">
                ในศูนย์ฝึกอบรมจะประกอบด้วย สิ่งอำนวยความสะดวกทันสมัยต่างๆ ที่จำลองมาจากสภาพหน้างานจริงๆ ไม่ว่าจะเป็นห้องพักลักษณะ บ้าน, condo , สำนักงาน และ โรงแรม ซึ่งคุณแม่บ้านจะได้รับการฝึกฝนให้สามารถรับมือกับ ลักษณะงานที่หลากหลายเกือบทุกประเภท และสร้างความมั่นใจให้กับคุณแม่บ้านก่อนเข้าไปทำงานจริง
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12"><h4>สมัครผู้ให้บริการ</h4></div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="card">
                <div class="card-body text-center">
                  <router-link :to="'/professional-register'" class="btn btn-warning btn-block" target="_blank">
                    {{ $t('message.apply.register') }}
                  </router-link>
                </div>
              </div>
            </div>
            <!-- <div class="col-md-4">
              <div class="card">
                <div class="card-body text-center">
                  <p>{{ $t('message.city.bangkok') }}</p>
                  <a href="https://goo.gl/eRtSYx"
                     target="_blank"
                     class="btn btn-warning btn-block">{{ $t('message.apply.register') }}</a>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card">
                <div class="card-body text-center">
                  <p>{{ $t('message.city.chiang_mai') }}</p>
                  <a href="https://goo.gl/VfzfAS"
                     target="_blank"
                     class="btn btn-warning btn-block">{{ $t('message.apply.register') }}</a>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card">
                <div class="card-body text-center">
                  <p>{{ $t('message.city.chonburi') }}</p>
                  <a href="https://goo.gl/yujSL4"
                     target="_blank"
                     class="btn btn-warning btn-block">{{ $t('message.apply.register') }}</a>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card">
                <div class="card-body text-center">
                  <p>{{ $t('message.city.rayong') }}</p>
                  <a href="https://goo.gl/9WaJM2"
                     target="_blank"
                     class="btn btn-warning btn-block">{{ $t('message.apply.register') }}</a>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card">
                <div class="card-body text-center">
                  <p>{{ $t('message.city.phuket') }}</p>
                  <a href="https://goo.gl/wSXejK"
                     target="_blank"
                     class="btn btn-warning btn-block">{{ $t('message.apply.register') }}</a>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </section>

    <div class="row mb-4">
      <div class="col-md-2">&nbsp;</div>
      <div class="col-md-8 col-12">
        <h4>{{ $t('message.apply.contact_data00') }}</h4>
        <h4>{{ $t('message.apply.contact_data01') }}</h4>
        <h4>{{ $t('message.apply.contact_data03') }}</h4>
      </div>
      <div class="col-md-2">&nbsp;</div>
    </div>

  </div>

</template>

<script>
  export default {
    data () {
      return {
        stepTitles: ['message.apply.how_it_works_title01',
          'message.apply.how_it_works_title02',
          'message.apply.how_it_works_title03',
          'message.apply.how_it_works_title04'],
        stepDetails: ['message.apply.how_it_works_detail01',
          'message.apply.how_it_works_detail02',
          'message.apply.how_it_works_detail03',
          'message.apply.how_it_works_detail04'],
        num: 0,
        appPictures: [
          '/static/img/professional-app-work01.png',
          '/static/img/professional-app-work02.png',
          '/static/img/professional-app-work03.png',
          '/static/img/professional-app-work04.png'
        ]
      }
    },
    metaInfo () {
      return {
        title: 'คุณแม่บ้าน BeNeat - สมัครแม่บ้านออนไลน์ รายได้ 4,000-7,000 บาท/สัปดาห์ สมัครง่าย รายได้ดี มีโบนัส จ่ายเงินตรงเวลา เลือกเวลาทำงานได้',
        link: [
          {
            rel: 'canonical',
            href: 'https://beneat.co/apply'
          }
        ],
        meta: [
          {
            vmid: 'description',
            name: 'description',
            content: 'BeNeat คุณแม่บ้านออนไลน์ - สมัครงานแม่บ้านออนไลน์ง่ายๆ งานอิสระ รายได้ดี 4,000-7,000 บาท/สัปดาห์ ไม่ต้องหาลูกค้าเอง รับเงินตรงเวลาทุกสัปดาห์ เลือกวัน-เวลาทำงานได้ สมัครง่ายในไม่กี่ขั้นตอน มีทีมงานดูแล สมัครเลย!'
          },
          {
            vmid: 'image',
            name: 'image',
            content: 'https://beneat.co/static/img/apply-news01.jpg'
          },
          {
            vmid: 'og:title',
            property: 'og:title',
            content: 'คุณแม่บ้าน BeNeat - สมัครแม่บ้านออนไลน์ รายได้ 4,000-7,000 บาท/สัปดาห์ สมัครง่าย รายได้ดี มีโบนัส จ่ายเงินตรงเวลา เลือกเวลาทำงานได้'
          },
          {
            vmid: 'og:description',
            property: 'og:description',
            content: 'BeNeat คุณแม่บ้านออนไลน์ - สมัครงานแม่บ้านออนไลน์ง่ายๆ งานอิสระ รายได้ดี 4,000-7,000 บาท/สัปดาห์ ไม่ต้องหาลูกค้าเอง รับเงินตรงเวลาทุกสัปดาห์ เลือกวัน-เวลาทำงานได้ สมัครง่ายในไม่กี่ขั้นตอน มีทีมงานดูแล สมัครเลย!'
          },
          {
            vmid: 'og:image',
            name: 'og:image',
            content: 'https://beneat.co/static/img/apply-news01.jpg'
          },
          {
            vmid: 'og:url',
            property: 'og:url',
            content: this.url
          },
          {
            vmid: 'og:type',
            property: 'og:type',
            content: 'website'
          },
          {
            vmid: 'og:locale',
            property: 'og:locale',
            content: 'th_TH'
          },
          {
            vmid: 'twitter:card',
            name: 'twitter:card',
            content: 'summary_large_image'
          },
          {
            vmid: 'twitter:title',
            name: 'twitter:title',
            content: 'คุณแม่บ้าน BeNeat - สมัครแม่บ้านออนไลน์ รายได้ 4,000-7,000 บาท/สัปดาห์ สมัครง่าย รายได้ดี มีโบนัส จ่ายเงินตรงเวลา เลือกเวลาทำงานได้'
          },
          {
            vmid: 'twitter:description',
            name: 'twitter:description',
            content: 'BeNeat คุณแม่บ้านออนไลน์ - สมัครงานแม่บ้านออนไลน์ง่ายๆ งานอิสระ รายได้ดี 4,000-7,000 บาท/สัปดาห์ ไม่ต้องหาลูกค้าเอง รับเงินตรงเวลาทุกสัปดาห์ เลือกวัน-เวลาทำงานได้ สมัครง่ายในไม่กี่ขั้นตอน มีทีมงานดูแล สมัครเลย!'
          },
          {
            vmid: 'twitter:image',
            name: 'twitter:image',
            content: 'https://beneat.co/static/img/apply-news01.jpg'
          }
        ]
      }
    },
    mounted () {
      setInterval(() => {
        this.num++
        if (this.num > 3) {
          this.num = 0
        }
      }, 5000)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/information/ApplyProfessional.vue